export function videoFrameTimes(duration, interval = 0.5) {
  const seconds = Number(duration);
  if (!Number.isFinite(seconds) || seconds <= 0) return [0];
  const step = Math.max(0.1, Number(interval) || 0.5);
  // Keep the preview useful and bounded: four samples from the first two
  // seconds and four from the final two seconds. This avoids a huge grid for
  // long videos while preserving both the opening and ending action.
  // Browser metadata often reports values such as 15.10 for a nominal
  // 15-second clip. Snap the timeline to the sampling interval so the labels
  // and selected frames remain exact 0.5-second values.
  const timelineEnd = Math.max(step, Math.round(seconds / step) * step);
  const seekEnd = Math.max(0, seconds - 0.05);
  const times = [];
  const add = (time) => {
    const value = Number(Math.max(0, Math.min(seekEnd, time)).toFixed(2));
    if (!times.some((item) => Math.abs(item - value) < 0.01)) times.push(value);
  };
  const firstCount = Math.max(1, Math.ceil(Math.min(2, seconds) / step));
  for (let index = 0; index < firstCount; index += 1) add(index * step);
  const lastStart = Math.max(0, timelineEnd - 2);
  for (let index = 0; index < firstCount; index += 1) add(lastStart + index * step);
  return times.sort((left, right) => left - right);
}

export function fittedFrameSize(width, height, maxEdge = 960) {
  const sourceWidth = Math.max(1, Number(width) || 1);
  const sourceHeight = Math.max(1, Number(height) || 1);
  const scale = Math.min(1, maxEdge / Math.max(sourceWidth, sourceHeight));
  return {
    width: Math.max(1, Math.round(sourceWidth * scale)),
    height: Math.max(1, Math.round(sourceHeight * scale)),
  };
}
